import React, { useRef, useCallback } from 'react';
import { InputAdornment, Tooltip } from '@mui/material';
import Close from '@mui/icons-material/Close';
import Search from '@mui/icons-material/Search';
import { normalizeText } from './searchFilter.helpers';

import { SearchBarStyled, SearchContainer } from './styles';
import { useTranslateMessage } from '../../localization';

const SearchFilter = ({ onSearchChange, querySearch, disabled, resultsCount, fullWidth, isMobile }) => {
  const searchRef = useRef(null);
  const translateMessage = useTranslateMessage();

  const handleInputChange = useCallback(
    e => {
      const inputValue = e.target?.value;
      if (inputValue.length <= 50) {
        onSearchChange(normalizeText(inputValue));
      }
    },
    [onSearchChange]
  );

  const handleInputClear = useCallback(() => onSearchChange(''), [onSearchChange]);

  const searchContent = () => (
    <SearchBarStyled
      inputRef={searchRef}
      fullWidth={fullWidth}
      variant="outlined"
      autoFocus
      autoComplete="off"
      placeholder={translateMessage('activeUser_searchFilterPlaceholder')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search onClick={() => searchRef.current.focus()} sx={{ fontSize: 24 }} />
          </InputAdornment>
        ),
        endAdornment: querySearch && (
          <InputAdornment position="end">
            <Close onClick={handleInputClear} sx={{ fontSize: 24, cursor: 'pointer' }} />
          </InputAdornment>
        ),
      }}
      inputProps={{
        'data-testid': 'search-bar',
      }}
      onKeyDown={e => {
        if (e.key === 'Escape') {
          searchRef.current.blur();
        }
      }}
      disabled={disabled}
      onChange={handleInputChange}
      value={querySearch}
    />
  );

  return (
    <SearchContainer>
      {isMobile ? (
        searchContent()
      ) : (
        <Tooltip
          PopperProps={{ disablePortal: true }}
          title={translateMessage('hot_keys_desctiption')}
          placement="right"
        >
          {searchContent()}
        </Tooltip>
      )}
    </SearchContainer>
  );
};

export default SearchFilter;
